<template>
    <el-aside width="180px" class="side-bar">
        <el-col :span="24" class="collapse-col" v-if="false">
            <el-radio-group v-model="isCollapse" style="margin-bottom: 20px">
                <el-radio-button v-if="!isCollapse" :value="true" size="small"><el-icon>
                        <ArrowLeftBold />
                    </el-icon></el-radio-button>
                <el-radio-button v-if="isCollapse" :value="false" size="small">
                    <el-icon>
                        <ArrowRightBold />
                    </el-icon>
                </el-radio-button>
            </el-radio-group>
        </el-col>
        <el-menu active-text-color="#ffd04b" background-color="#545c64" :router="true" :unique-opened="true"
            :default-active="activeMenu" :default-openeds="openMenus" text-color="#fff" :collapse="isCollapse">

            <template v-for="item in menu">
                <el-menu-item :index="item.index" v-if="!item.children || item.children?.length === 0"
                    :key="item.index">
                    <el-icon v-if="item.icon">
                        <component :is="item.icon"></component>
                    </el-icon>
                    <template #title>{{ item.label }}</template>
                </el-menu-item>

                <el-sub-menu :index="item.index" v-if="item.children?.length > 0" :key="item.index">
                    <template #title>
                        <el-icon v-if="item.icon">
                            <component :is="item.icon"></component>
                        </el-icon>
                        <span>{{ item.label }}</span>
                    </template>
                    <template v-for="child in item.children" :key="child.index">
                        <el-menu-item :index="child.index">
                            <el-icon v-if="child.icon">
                                <component :is="child.icon"></component>
                            </el-icon>
                            <template #title>{{ child.label }}</template>
                        </el-menu-item>
                    </template>
                </el-sub-menu>
            </template>
        </el-menu>
    </el-aside>
</template>

<script setup>
import { ref, markRaw, onMounted, watch } from 'vue';
import { HomeFilled, User, Avatar, Film, Box, CreditCard, Comment, Message, DocumentCopy, CirclePlus, Ticket } from '@element-plus/icons-vue';
import { useRoute } from 'vue-router';

const route = useRoute();

const activeMenu = ref(route.path);
const openMenus = ref([]);

const isCollapse = ref(false);
const menu = ref([]);

const init = () => {
    const defaultMenu = [
        {
            index: "/",
            label: "主页",
            icon: markRaw(HomeFilled),
            permission: true,
        },
        {
            index: "/users",
            label: "用户列表",
            icon: markRaw(User),
            permission: true,
        },
        {
            index: "card",
            label: "卡包/卡片",
            icon: markRaw(Box),
            permission: true,
            children: [
                {
                    index: "/categories",
                    label: "分类配置",
                    permission: true,
                },
                {
                    index: "/tags",
                    label: "标签配置",
                    permission: true,
                },
                {
                    index: "/cards",
                    label: "抽取物配置",
                    permission: true,
                },
                {
                    index: "/fragments",
                    label: "碎片配置",
                    permission: true,
                },
                {
                    index: "/packs",
                    label: "卡包配置",
                    permission: true,
                },
            ]
        },
        {
            index: "/recharge/items",
            label: "充值项目配置",
            icon: markRaw(CreditCard),
            permission: true,
        },
        {
            index: "/ships",
            label: "卡片提现",
            icon: markRaw(Box),
            permission: true,
        },
        {
            index: "/feedbacks",
            label: "反馈列表",
            icon: markRaw(Comment),
            permission: true,
        },
        {
            index: "/drawlogs",
            label: "用户抽卡列表",
            icon: markRaw(Ticket),
            permission: true,
        },
        {
            index: "/exchangelogs",
            label: "积分兑换记录",
            icon: markRaw(CirclePlus),
            permission: true,
        },
        {
            index: "/snapshots",
            label: "数据快照",
            icon: markRaw(DocumentCopy),
            permission: true,
        },
        {
            index: "managers",
            label: "管理员",
            icon: markRaw(Avatar),
            permission: true,
            children: [
                {
                    index: "/managers",
                    label: "管理员配置",
                    permission: true,
                }
            ]
        },
    ];
    menu.value = defaultMenu.filter((e) => {
        if (e.permission === false) {
            return false;
        }
        if (e.children && e.children.length > 0) {
            e.children.filter(i => {
                return i.permission !== false;
            });
        }
        return true;
    });
};

function getOpenMenu(path) {
    let oms = [];
    menu.value.forEach(item => {
        if (item.children && item.children.length > 0) {
            item.children.forEach(e => {
                if (e.index === path) {
                    oms.push(item.index);
                }
            });
        }
    });
    return oms;
}

onMounted(() => {
    init();
});

watch(
    () => route.path,
    (newPath) => {
        activeMenu.value = newPath;
        openMenus.value = getOpenMenu(newPath);
    }
);
</script>

<style scoped>
:deep(.el-menu) {
    border: 0;
}

.side-bar {
    min-height: calc(100vh - 20px);
    background-color: #545c64;
}

.collapse-col {
    text-align: end;
}
</style>
